import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Modal from '@mui/material/Modal';
import { useCatalogueContext } from '../../../Catalogue/CatalogueContext';
import CloseIcon from '@mui/icons-material/Close';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import UsersList from '../../UsersList';
import Profile from '../../Profile';

const drawerWidth = 240;

export default function AdminDashboard() {
  const { isUsersModalOpen, setUsersModalOpen } = useCatalogueContext();
  const [selectedTab, setSelectedTab] = React.useState("My Profile");

  const mappingItems = [
    { text: "My Profile", icon: <PersonIcon />, render: <Profile />, },
    { text: "Users list", icon: <PeopleAltIcon />, render: <UsersList status={"confirmed"} /> },
    { text: "Confirm User", icon: <PersonAddIcon />, render: <UsersList status={"unconfirmed"} /> },
  ]

  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={isUsersModalOpen}
      closeAfterTransition
      sx={{ bgcolor: "white", zIndex: 10 }}
    >
      <Box sx={{ bgcolor: "#f3f6f9", height: '100vh', display: 'flex' }}>
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
          }}
        >
          <Box sx={{ overflow: 'auto' }}>
            <List>
              {mappingItems.map((item, index) => (
                <ListItem key={item.text} disablePadding >
                  <ListItemButton selected={selectedTab === item.text} onClick={() => setSelectedTab(item.text)}>
                    <ListItemIcon>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                </ListItem>
              ))}
              <ListItem key={"close"} disablePadding>
                <ListItemButton onClick={() => setUsersModalOpen(false)}>
                  <ListItemIcon>
                    <CloseIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Close"} />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: 3, overflow: 'auto', width: `calc(100% - ${drawerWidth}px)`, }}>
          {mappingItems.find(item => item.text === selectedTab)?.render}
        </Box>
      </Box>
    </Modal >
  );
}

